var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorOption},on:{"change":_vm.onEditorChange,"ready":function($event){return _vm.onEditorReady($event)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }